import { rankingItems } from '@/mocks/homeData';

const tagColorMap: Record<string, string> = {
  '爆': 'bg-accent-500 text-white',
  '热': 'bg-primary-500 text-white',
  '新': 'bg-secondary-500 text-white',
  '荐': 'bg-secondary-500 text-white',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              吃瓜热榜
            </h2>
            <p className="mt-1 text-sm text-foreground-500">
              实时热度排行，今日必吃大瓜一网打尽
            </p>
          </div>
          <div className="flex items-center gap-2 text-xs text-foreground-400">
            <i className="ri-refresh-line"></i>
            <span>实时更新</span>
          </div>
        </div>

        <div className="space-y-2">
          {rankingItems.map((item, idx) => (
            <div
              key={idx}
              className="flex items-center gap-4 p-4 rounded-xl bg-background-100 border border-background-200/70 hover:border-accent-300/60 transition-all duration-200 cursor-pointer"
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-lg font-heading font-bold text-sm shrink-0 ${
                idx < 3
                  ? 'bg-accent-500 text-white'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-foreground-900 line-clamp-1">
                  {item.title}
                </h3>
              </div>

              <span className={`text-xs px-2 py-0.5 rounded-full font-medium shrink-0 ${tagColorMap[item.tag] || 'bg-background-200 text-foreground-500'}`}>
                {item.tag}
              </span>

              <div className="hidden sm:flex items-center gap-1 text-sm font-semibold text-accent-600 shrink-0">
                <i className="ri-fire-line text-xs"></i>
                <span>{item.heat}</span>
              </div>

              <i className="ri-arrow-right-s-line text-foreground-300 shrink-0 hidden sm:block"></i>
            </div>
          ))}
        </div>

        <div className="text-center mt-8">
          <a
            href="#cards"
            className="inline-flex items-center gap-2 text-sm font-medium text-accent-600 hover:text-accent-700 transition-colors cursor-pointer"
          >
            查看更多热门
            <i className="ri-arrow-down-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}